// Classic › team page (#1119). Shared words (Roster, Season, Games, the
// competition picker, stats-scope tabs) come from useLabels(); sport-pack
// record columns and tiles come from the pack.

const en = {
  notFoundTitle: 'Team Not Found',
  notFoundBody: 'This team does not exist',
  backToTeams: 'Back to Teams',
  wins: 'Wins',
  losses: 'Losses',
  statsHeading: 'Statistics',
  seasonSelectLabel: 'Select Season',
  seasonSelectPlaceholder: 'Choose a season...',
  recordHeading: 'Record & Scoring',
  /** Basketball's record row (other sports use the pack's standings columns). */
  record: {
    gamesPlayed: 'GP',
    wins: 'W',
    losses: 'L',
    pointsFor: 'PF',
    pointsAgainst: 'PA',
    pointDiff: '+/-',
  },
  /** Basketball's per-game tiles. */
  perGame: {
    points: 'Points Per Game',
    rebounds: 'Rebounds Per Game',
    assists: 'Assists Per Game',
    totalPoints: (n: number | string) => `${n} total points`,
    totalRebounds: (n: number | string) => `${n} total rebounds`,
    totalAssists: (n: number | string) => `${n} total assists`,
  },
  /** Basketball's season totals. */
  totals: {
    steals: 'Steals',
    blocks: 'Blocks',
    threePointers: '3-Pointers',
  },
  winPct: 'Win %',
  /** Under a per-game tile: "212 total goals" (the stat name is the pack's, lower-cased). */
  tileTotal: (value: string, statLabel: string) => `${value} total ${statLabel.toLowerCase()}`,
  noPlayers: 'No players available',
  /** The result column in the games list. */
  outcome: {
    win: 'W',
    loss: 'L',
    draw: 'D',
    live: 'LIVE',
  },
  /** Before the opponent: a home game. Away games show "@". */
  versus: 'vs',
  replayBadge: '▶ VOD',
  photos: {
    heading: 'Photos',
    viewAll: 'View all photos →',
    open: 'Open photo',
  },
}

export default en
